export const SET_ARTIST = 'SET_ARTIST';
export const SET_SONGLIST = 'SET_SONGLIST';
export const SET_UPLOADS = 'SET_UPLOADS';
export const SET_MP3S = 'SET_MP3S';
export const SET_GIGS = 'SET_GIGS';
export const SET_VIDEOS = 'SET_VIDEOS';
export const SET_YOUTUBEVIDEOS = 'SET_YOUTUBEVIDEOS';
export const SET_INSTAGRAM = 'SET_INSTAGRAM';
export const SET_GALLERY = 'SET_GALLERY';